import React, { ReactElement, ReactNode } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .5)',
    borderLeft: 'none',
    borderRight: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    fontWeight: 'bolder',
    backgroundColor: 'rgba(255,255,255)',
    borderBottom: '1px solid rgba(0, 0, 0, .5)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

type Props = {
  label: string;
  expanded: boolean;
  children: ReactNode;
  onChange?: (event: React.ChangeEvent<unknown>, expanded: boolean) => void;
};

function AccordionTab(props: Props): ReactElement {
  const { children, expanded, label, onChange } = props;

  return (
    <Accordion expanded={expanded} onChange={onChange} square>
      <AccordionSummary
        expandIcon={expanded ? <RemoveIcon /> : <AddIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        {label}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

export default AccordionTab;
